import { isChannelRequestError } from '../errors';

const ENTITY_NOT_DOWNLOADED = 'EntityNotDownloadedError';

/**
 * The worker could not read one item because its entity is not downloaded
 * (offline, a download that failed): the item may exist. Not the same answer
 * as "no such item".
 */
export class EntityNotDownloadedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = ENTITY_NOT_DOWNLOADED;
  }
}

/** Whether the worker answered a read by id with `EntityNotDownloadedError` (its name travels in the cause). */
export function isEntityNotDownloadedAnswer(error: unknown): boolean {
  if (!isChannelRequestError(error)) {
    return false;
  }
  const { cause } = error;
  return typeof cause === 'object' && cause !== null && (cause as { name?: unknown }).name === ENTITY_NOT_DOWNLOADED;
}
